import React from 'react';

import gameLogo from '../../../assets/images/game/monti-logo.png';

const GameMainTopLogo = () => {
  return (
    <div className='monti-logo'>
      <img src={gameLogo} alt='' />
    </div>
  );
};

export default GameMainTopLogo;
